import ApiService from '@/services/api.service'

const AllergyService = {
    getAll(parameter, addExtraParams = false) {
      const params = {
        SearchCriteria: parameter.SearchCriteria,
        PageSize: parameter.PageSize,
        PageNumber: parameter.PageNumber,
        PatientCode: parameter.PatientCode
      };

      if (addExtraParams) {
        // Add extra params , only for report listing
        params.AllergyCodeList = parameter.AllergyCodeList
        params.PatientCodeList = parameter.PatientCodeList 
        params.PatientIsActive = parameter.PatientIsActive;
        params.ActiveAdmission = parameter.ActiveAdmission;
        params.IsActive = parameter.IsActive;
        params.DateFrom = parameter.DateFrom; 
        params.DateTo = parameter.DateTo;
        params.Severity = parameter.Severity;

        return ApiService.getWithArray('/PatientAllergies',params); 
      }

      const requestData = {
        method: 'get',
        url: "/PatientAllergies/",
        headers: {},
        params: params
      };
      return ApiService.customRequest(requestData);
    },

    
    get( id) {
      return ApiService.get(`/PatientAllergies/${id}`);
    },

    addAllergy(data){
      return ApiService.post(`/PatientAllergies`,data)
    },

    deleteAllergy(id){
      return ApiService.delete(`/PatientAllergies/${id}`)
    },

    update(RecordId,Allergy){
      return ApiService.put(`/PatientAllergies/${RecordId}`,Allergy)
    },

    getPatientNoKnownAllergies(id){
      return ApiService.get(`/PatientAllergies/PatientNoKnownAllergies/${id}`)
    },

    updtPatientNoKnownAllergies(pCode, pAllergies){
      return ApiService.put(`/EhrPatientNoKnownAllergies/${pCode}`,pAllergies)
    },

    getPatientNoKnownAllergie( code ) {
        const requestData = {
          method: 'get',
          url: "/EhrPatientNoKnownAllergies/",
          headers: {
          },
          params: { 
            PatientCode: code          
          }
        }     
        return ApiService.customRequest(requestData);         
      },
}
  
  export default AllergyService;